<template>
    <div>
        <div class="custom-table governance" v-if="$i18n.locale=='en'">
            <div class="table-heading">Composition of the Board of Directors:</div>
            <div class="trow head">
                <div class="th" data-width="20%"><strong>NAME</strong> </div>
                <div class="th" data-width="18%"><strong>CLASSIFICATION</strong> </div>
                <div class="th" data-width="18%"><strong>EDUCATION</strong></div>
                <div class="th" ><strong>PROFESSIONAL</strong><br> <strong>EXPERIENCE</strong></div>
                <div class="th" ><strong>DATE OF ELECTION/</strong><br><strong>APPOINTMENT</strong> </div>
            </div>
            <div class="trow">
                <div data-width="20%"><strong>Ahmed Tahous Al Tahous<br></strong>Chairman</div>
                <div data-width="18%">Non-executive </div>
                <div data-width="18%">Bachelor’s Degree in Business Administration from Kuwait University </div>
                <div>35 years in the banking<br> and investment sectors in<br> the global and Kuwaiti markets</div>
                <div>12 Mar 2017</div>
            </div>
            <div class="trow">
                <div data-width="20%"><strong>Bader Nasser Al-Kharafi</strong> <br>Vice Chairman Group CEO</div>
                <div data-width="18%">Executive</div>
                <div data-width="18%">Master of Business<br>Administration from London Business School</div>
                <div>
                    Industrial and banking sector, Investment and business sectors, Non-profit institutions, Telecommunications and mechanical engineering sector
                </div>
                <div>12 Apr 2011</div>
            </div>
            <div class="trow">
                <div data-width="20%"><strong>Talal Said Al Mamari </strong></div>
                <div data-width="18%">Non-executive</div>
                <div data-width="18%">Bachelor’s Degree in Business Administration from Duquesne University,  Pittsburgh</div>
                <div>
                    Finance experience in the telecommunications sector
                </div>
                <div>17 Sep 2017</div>
            </div>
            <div class="trow">
                <div data-width="20%"><strong>Zaki Hilal Saud </strong><br>Al Busaidi</div>
                <div data-width="18%">Non-executive</div>
                <div data-width="18%">Master’s degree in Public Administration from Exeter  University in the UK</div>
                <div>
                    20 years in the civil service sectors, port services, investment and insurance and communications
                </div>
                <div>19 Mar 2020</div>
            </div>
            <div class="trow">
                <div data-width="20%"><strong>Atif Said Rashid</strong><br>Al Siyabi</div>
                <div data-width="18%">Non-executive</div>
                <div data-width="18%">
                    Bachelor of Engineering in Computer Hardware and Networking Technology from Coventry University in the UK

                </div>
                <div>
                    17 years in information technology, business development, innovative technological solutions and information systems, investment and communications
                </div>
                <div>19 Mar 2020</div>
            </div>
            <div class="trow">
                <div data-width="20%"><strong>Aladdin Baitfadhil</strong></div>
                <div data-width="18%">Non-executive</div>
                <div data-width="18%">
                    Bachelor’s degree in Electrical and Electronics Engineering from Sultan Qaboos University.

                </div>
                <div>
                    18 years in the information and communication technology sector
                </div>
                <div>12 Oct 2020</div>
            </div>
            <div class="trow">
                <div data-width="20%"><strong>Nasser bin Suleiman</strong><br>Al-Harthy</div>
                <div data-width="18%">Non-executive </div>
                <div data-width="18%">Master’s degree in business administration (MBA) from the University of Victoria, Australia</div>
                <div>
                    21 years in the investment, economic, financial, information management, legal and compliance sectors
                </div>
                <div>12 Oct 2020</div>
            </div>
            <div class="trow">
                <div data-width="20%"> <strong>Abdulrahman Mohammad Ibrahim Al Asfour</strong><br>Independent</div>
                <div data-width="18%">Independent </div>
                <div data-width="18%">Bachelor’s Degree in Business Administration Major from Kuwait University</div>
                <div>
                    Technical expertise in the application of IT solutions,<br> audit and finance

                </div>
                <div>28 Mar 2018</div>
            </div>
            <div class="trow">
                <div data-width="20%"><strong>Yousef Khaled Al-Abdulrazzaq</strong></div>
                <div data-width="18%">Non-executive </div>
                <div data-width="18%">Bachelor’s Degree in Business Administration<br> – Finance Major from Kuwait University</div>
                <div>
                    Audit and investment expertise within the general reserve sector and investment funds

                </div>
                <div>30 May 2018</div>
            </div>
            <div class="trow">
                <div data-width="20%"><strong>Hatmal Farouq Al Qadi</strong></div>
                <div data-width="18%">Secretary</div>
                <div data-width="18%">Master of Laws (L.L.M) from Coventry University in the UK</div>
                <div>
                    Legal Consultancy Telecommunications sector
                </div>
                <div>12 May 2015</div>
            </div>
        </div>
        <div class="custom-table governance" v-if="$i18n.locale=='ar'">
            <div class="table-heading">تشكيل مجلس الإدارة</div>
            <div class="trow head">
                <div class="th" data-width="20%"><strong>الاسم</strong> </div>
                <div class="th" data-width="18%"><strong>تصنيف العضو</strong> </div>
                <div class="th" data-width="18%"><strong>المؤهل العلمي</strong></div>
                <div class="th" ><strong>الخبرة</strong><br> <strong>العملية</strong></div>
                <div class="th" ><strong>تاريخ الانتخاب/</strong><br><strong>التعيين</strong> </div>
            </div>
            <div class="trow">
                <div data-width="20%"><strong>أحمد طاحوس الطاحوس<br></strong>رئيس مجلس الإدارة</div>
                <div data-width="18%">غير تنفيذي </div>
                <div data-width="18%">بكالوريوس إدارة الأعمال بتخصص في الاقتصاد من جامعة الكويت </div>
                <div>35 عاما في قطاع الخدمات المصرفية، وقطاع الاستثمار في الأسواق العالمية والكويتية</div>
                <div>12 مارس 2017</div>
            </div>
            <div class="trow">
                <div data-width="20%"><strong>بدر ناصر الخرافي</strong> <br>نائب رئيس مجلس الإدارة والرئيس التنفيذي للمجموعة</div>
                <div data-width="18%">تنفيذي</div>
                <div data-width="18%">ماجستير إدارة الأعمال<br>من كلية لندن للأعمال </div>
                <div>
                    القطاع الصناعي والمصرفي،قطاعات الاستثمار والأعمال، قطاع الاتصالات، والهندسة الميكانيكية، والمؤسسات غير الربحية
                </div>
                <div>12 أبريل 2011</div>
            </div>
            <div class="trow">
                <div data-width="20%"><strong>طلال بن سعيد المعمري </strong></div>
                <div data-width="18%">غير تنفيذي</div>
                <div data-width="18%"> بكالوريوس إدارة الأعمال من جامعة دوكيسين - بيتسبيرج</div>
                <div>
                    خبرة في الشؤون المالية قطاع الاتصالات 
                </div>
                <div>17 سبتمبر 2017</div>
            </div>
            <div class="trow">
                <div data-width="20%"><strong>زكي بن هلال بن سعود <br>البوسعيدي</strong></div>
                <div data-width="18%">غير تنفيذي</div>
                <div data-width="18%">ماجستير الإدارة العامة من جامعة اكستر بالمملكة المتحدة</div>
                <div>
                    20 عاما  في قطاعات الخدمة المدنية خدمات المواني والاستثمار والتأمين والاتصالات
                </div>
                <div>19 مارس 2020</div>
            </div>
            <div class="trow">
                <div data-width="20%"><strong>عاطف بن سعيد بن راشد<br>السيابي</strong></div>
                <div data-width="18%">غير تنفيذي</div>
                <div data-width="18%">
                    بكالوريوس هندسة في أجهزة الكمبيوتر وتكنولوجيا الشبكات من جامعة كوفنتري بالمملكة المتحدة

                </div>
                <div>
                    17 عاما في مجالات تكنولوجيا المعلومات وتطوير الأعمال والحلول التكنولوجية المبتكرة ونظم المعلومات، بالإضافة إلى الاستثمار والاتصالات
                </div>
                <div>19 مارس 2020</div>
            </div>
            <div class="trow">
                <div data-width="20%"><strong>علاء الدين بيت فاضل</strong></div>
                <div data-width="18%">غير تنفيذي</div>
                <div data-width="18%">
                   بكالوريوس هندسة كهربائية إلكترونية من جامعة السلطان قابوس

                </div>
                <div>
                   18 عاماً في قطاع تكنولوجيا المعلومات والاتصالات
                </div>
                <div>12 أكتوبر 2020</div>
            </div>
            <div class="trow">
                <div data-width="20%"><strong>ناصر بن سليمان<br>الحارثي</strong></div>
                <div data-width="18%">غير تنفيذي </div>
                <div data-width="18%">ماجستير إدارة الاعمال من جامعة فكتوريا في أستراليا </div>
                <div>
                    21 عاما في القطاعات الاستثمارية والاقتصادية والمالية
                </div>
                <div>12 أكتوبر 2020</div>
            </div>
            <div class="trow">
                <div data-width="20%"> <strong>عبد الرحمن محمد إبراهيم العصفور</strong></div>
                <div data-width="18%">مستقل </div>
                <div data-width="18%">بكالوريوس إدارة الأعمال بتخصص في المحاسبة من جامعة الكويت</div>
                <div>
                    خبرات تقنية في تطبيق حلول تكنولوجيا المعلومات وخبرات في مجال التدقيق والمالية

                </div>
                <div>28 مارس 2018</div>
            </div>
            <div class="trow">
                <div data-width="20%"><strong>يوسف خالد العبدالرزاق</strong></div>
                <div data-width="18%">غير تنفيذي </div>
                <div data-width="18%">بكالوريوس إدارة الأعمال بتخصص في المالية من جامعة الكويت</div>
                <div>
                    خبرات في مجال التدقيق والاستثمارات ضمن قطاعات الاحتياطي العام والمحافظ والصناديق الاستثمارية 

                </div>
                <div>30 مايو  2018</div>
            </div>
            <div class="trow">
                <div data-width="20%"><strong>حتمل فاروق القاضي</strong></div>
                <div data-width="18%">أمين السر</div>
                <div data-width="18%">ماجستير قانون من جامعة كوفنتري في المملكة المتحدة</div>
                <div>
                    المحاماة والاستشارات القانونية، قطاع الاتصالات
                </div>
                <div>12 مايو  2015</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>